import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";
import "./Lobby.css";
import { API_URL } from "./App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Lobby() {
  const [gameId, setGameId] = useState("");
  const [playerId, setPlayerId] = useState("");
  const [kreuzMode, setKreuzMode] = useState(true);
  const [spielVorschlag, setSpielVorschlag] = useState(true);
  const [isQuanten, setIsQuanten] = useState(false);
  const [shuffleCount, setShuffleState] = useState(15);
  const [joinedGameId, setJoinedGameId] = useState("");
  const [availableGames, setAvailableGames] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();

  const ws = useRef(null); 

  useEffect(() => {
    ws.current = new WebSocket(`${API_URL.replace("http", "ws")}/ws/lobby`);

    ws.current.onopen = () => console.log("ws opened");
    ws.current.onclose = () => console.log("ws closed");

    const wsCurrent = ws.current;
  }, []);

  useEffect(() => {
    ws.current.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        switch (data.type) {
          case "game_list":
            setAvailableGames(data.games || []);
            break;
          case "game_created":
            setSuccess(`Game "${data.gameId}" created successfully!`);
            setError("");
            break;
          case "game_joined":
            setSuccess(`Successfully joined game "${data.gameId}"`);
            setJoinedGameId(data.gameId);
            setError("");
            break;
          case "game_started":
            navigate(`/game/${data.gameId}/${data.playerId}`);
            ws.current.close(); // Close WebSocket before navigating
            break;
          case "error":
            setError(data.message || "An error occurred.");
            break;
          default:
            console.warn("Unknown WebSocket message type:", data.type);
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    ws.current.onerror = (error) => {
      console.error("WebSocket error:", error);
      setError("WebSocket connection error.");
    };
  }, [navigate, joinedGameId, playerId]); // Dependencies for useEffect

  const sendMessage = (message) => {
    if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      ws.current.send(JSON.stringify(message));
    } else {
      setError("WebSocket is not connected.");
    }
  };

  const createGame = () => {
    if (!gameId.trim()) {
      setError("Game ID cannot be empty.");
      return;
    }
    sendMessage({ type: "create_game", gameId: gameId, kreuzMode, spielVorschlag, shuffleCount, isQuanten });
  };

  const joinGame = (gameIdToJoin) => {
    if (!playerId.trim()) {
      setError("Player ID cannot be empty.");
      return;
    }
    sendMessage({ type: "join_game", gameId: gameIdToJoin, playerId });
  };

  const startGame = (gameIdToStart) => {
    sendMessage({ type: "start_game", gameId: gameIdToStart });
  };

  const createTutorialGame = (tutorialName) => {
    sendMessage({ type: "tutorial", tutorialName: tutorialName });
  };

  const createQuantenTutorialGame = (tutorialName) => {
    sendMessage({ type: "quanten_tutorial", tutorialName: tutorialName });
  };

  const filteredGames = availableGames.filter(
    game => game.is_quanten === isQuanten
  );

  console.log(availableGames);

  return (
    <>
    <div className={`overlay ${isQuanten ? "show" : ""}`} />

    <div id="game" className={`page`}>
      <div class="header">
        <h2>Schafkopf Lobby</h2>
      </div>

      {error && (
        <div class="error">
          <div className="red">
            <FontAwesomeIcon icon="fa-solid fa-circle-xmark" />
            <p>{error}</p>
          </div>
        </div>
      )}
      {success && (
        <div class="success">
          <div className="green">
            <FontAwesomeIcon icon="fa-solid fa-check" />
            <p>{success}</p>
          </div>
        </div>
      )}

      <div class="players">
        <h2>Create a Game</h2>
        <input
          placeholder="Game ID"
          value={gameId}
          onChange={(e) => setGameId(e.target.value)}
        />
        <div>
        <input type="checkbox"
               defaultChecked={true}
               onChange={e => setKreuzMode(e.target.value)}
        />
            Kreuz nach dem Solo
        <input type="checkbox"
               defaultChecked={false}
               onChange={e => setIsQuanten(e.target.checked)}
        />
            Quanten
        </div>

        <button onClick={createGame}>Create Game</button>
      </div>
      <div class="players">
        <h2>Join a Game</h2>
        <input
          placeholder="Your Player ID"
          value={playerId}
          onChange={(e) => setPlayerId(e.target.value.trim())}
        />
      </div>
      <ul>
        {filteredGames.length > 0 ? (
          filteredGames.map((game) => (
            <li key={game.id}>
              {joinedGameId !== game.id ? (
                <span>
                  {game.id}{" "}
                  <button onClick={() => joinGame(game.id)}>Join</button>
                </span>
              ) : (
                <span className="green">You joined Game {game.id} </span>
              )}
              {game.player_count}/4
            </li>
          ))
        ) : (
          <p>No games available</p>
        )}
      </ul>
      
      {!isQuanten ? (
        <div className={"tutorialButtons"}>
          {["tutorial01", "tutorial02", "tutorial03"].map((name) => (
            <button key={name} onClick={() => createTutorialGame(name)}>
              {name}
            </button>
          ))}
        </div>
      ):
      (
        <div className={"tutorialButtons"}>
          {["quantenTutorial01", "quantenTutorial02"].map((name) => (
            <button key={name} onClick={() => createQuantenTutorialGame(name)}>
              {name}
            </button>
          ))}
        </div>
      )
      }
      

      
    </div>
  </>
     );
}

export default Lobby;
